import {getSheet} from "../sheets";
import {find, findIndex} from "../helpers/array";

export function setCellEditor(row, column, editor, page) {
	page = page || this.getActiveSheet();
	let value;

	if(page == this.getActiveSheet()){
		const line = this._table._ssEditors[row] = this._table._ssEditors[row] || {};
		value = line[column] || null;
		line[column] = editor;

		if (editor && editor.editor){
			this._table.addCellCss(row,column, "ss_editor");
		} else {
			delete this._table._ssEditors[row][column];
			this._table.removeCellCss(row,column, "ss_editor");
		}
	}
	else{
		const sheet = getSheet(this, page);
		if(!sheet) return;

		if(!sheet.content.editors)
			sheet.content.editors = [];

		const index = findIndex(sheet.content.editors, editor => editor[0] == row && editor[1] == column);
		if(index != -1){
			value = sheet.content.editors[index][2];
			sheet.content.editors.splice(index, 1);
		}
		else if(!editor) return;

		if(editor)
			sheet.content.editors.push([row, column, editor]);
	}

	this.callEvent("onAction", ["dropdown", { row, column, value, newValue:editor, page }]);
}

export function getCellEditor(row, column, page){
	if(page && page != this.getActiveSheet()){
		const sheet = getSheet(this, page);
		if(sheet && sheet.content.editors){
			const editor = find(sheet.content.editors, editor => editor[0] == row && editor[1] == column);
			return editor ? editor[2] : null;
		}
	}
	else {
		let line = this._table._ssEditors[row] || {};
		return line[column] || null;
	}
}